import { match } from "ts-pattern";

const appName = import.meta.env.VITE_APP as string;

const loader = match(appName)
    .with("app-lobbie", () => import("./app-lobbie"))
    .with("app-admin", () => import("./app-admin"))
    .with("app-telehealth-demo", () => import("./app-telehealth-demo"))
    .otherwise((unknown) => {
        console.warn(`Unknown VITE_APP "${unknown}", falling back to default "app-lobbie"`);
        return import(`./app-lobbie`);
    });

loader.catch((e) => {
    console.error(`Failed to load ${appName}`, e);
    throw e;
});
